<template>
  <v-toolbar
    flat
    style="position: fixed; width: 100%; z-index: 4"
    class="grey lighten-3"
  >
    <RemoveFromCollection
      v-if="collectionId && canDelete"
      :collectionId="collectionId"
    />

    <ShareCollection
      v-if="collectionId"
      :collectionId="parseInt(collectionId)"
    />

    <AddToCollection v-if="!collectionId" />

    <PublishSelectedButton />

    <DownloadDialog :buttonText="'Download'" :collectionId="collectionId" />

    <v-btn
      v-if="currentUser.permissions.create_collections"
      right
      class="ml-2"
      :disabled="itemsCount <= 0"
      color="primary"
      @click="toggleShowSelected()"
    >
      <span class="d-none d-md-flex">Show selected</span>
      <v-icon right>mdi-eye</v-icon>
    </v-btn>

    <EditCollection v-if="collectionId" />

    <SelectAllButton />

    <CollectionInfomation v-if="collectionId" />
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { TOGGLE_SHOW_SELECTED, FETCH_COLLECTION } from "@/store/actions.type";

export default {
  name: "ImagesToolbar",
  data: () => ({
    collectiondialog: false,
    downloaddialog: false,
    isCollection: false,
    collectionId: false,
  }),
  computed: {
    itemsCount() {
      return this.selectedImages.length;
    },
    canDelete() {
      if(this.activeExpClient) {
      if (
        this.activeExpClient.id === this.collection.owner.id ||
        this.currentUser.roles.includes("client-manager") === true
      ) {
        return true;
      }
      return false;
      }
    },
    ...mapGetters([
      "selectedImages",
      "collections",
      "collection",
      "showSelected",
      "currentUser",
      "activeExpClient",
    ]),
  },
  mounted() {
    if (this.$route.params.collectionId) {
      this.collectionId = this.$route.params.collectionId;
      console.log(this.collection);
      if (!this.collection.id !== this.collectionId) {
        store
          .dispatch(FETCH_COLLECTION, {
            clientId: this.$route.params.clientId,
            collectionId: this.collectionId,
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  },
  methods: {
    toggleShowSelected() {
      store.dispatch(TOGGLE_SHOW_SELECTED);
    },
  },
};
</script>
